import React from 'react';
import { Grid, Paper, Typography } from '@material-ui/core';
import cx from "classnames";

interface RemedialInfoProps {
    remedialQuestionLength: number;
    classes: any;
    mainContainerClassName?: any
}

const RemedialInfo = (props: RemedialInfoProps) => {
    const { classes, remedialQuestionLength, mainContainerClassName = classes.paddingSM } = props
    return (
        <Paper className={mainContainerClassName} elevation={0}>
            <Grid container>
                <Typography
                    variant="body2"
                    className={cx(classes.fontSM, classes.greyColor, classes.metaInfoBox, classes.width100)}
                >
                    <span className={classes.feedbackContainer}>
                        {`Remedial Question${remedialQuestionLength > 1 ? '(s)' : ''}: ${remedialQuestionLength}`}
                    </span>
                </Typography>
            </Grid>
        </Paper >
    );
};

// @ts-ignore
export default (React.memo(RemedialInfo));
